import script from "./WorkflowDetailsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDetailsHeader.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDetailsHeader.vue?vue&type=style&index=0&id=95cb681a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95cb681a"]])

export default __exports__